import { render, staticRenderFns } from "./a-svg-logo-x9.vue?vue&type=template&id=28f7f7e8&scoped=true"
import script from "./a-svg-logo-x9.vue?vue&type=script&lang=js"
export * from "./a-svg-logo-x9.vue?vue&type=script&lang=js"
import style0 from "./a-svg-logo-x9.vue?vue&type=style&index=0&id=28f7f7e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f7f7e8",
  null
  
)

export default component.exports